import type { Router, LocationQueryRaw } from 'vue-router'
import Layout from '@/layout/index.vue'
import ParentView from '@/components/ParentView/index.vue'

// Read the permission-filtered sidebar in its existing order, without changing it.
export function menuLanding(menus: any[], router: Router, parent = ''): { path: string; query?: LocationQueryRaw } | undefined {
  for (const menu of menus || []) {
    if (menu.hidden || /^(https?:|mailto:|tel:)/.test(menu.path || '')) continue
    const path = menu.path?.startsWith('/') ? menu.path : `${parent}/${menu.path || ''}`.replace(/\/+/g, '/')
    if (menu.children?.length) {
      const child = menuLanding(menu.children, router, path)
      if (child) return child
      continue
    }
    if (['/', '/index', '/no-access'].includes(path) || path.includes(':')) continue
    if (!menu.component || menu.component === Layout || menu.component === ParentView) continue
    const matched = router.resolve(path).matched
    const leaf = matched[matched.length - 1]
    if (!leaf || leaf.path.includes(':pathMatch') || leaf.redirect || !leaf.components?.default) continue
    let query = menu.query
    if (typeof query === 'string') {
      try { query = JSON.parse(query) } catch { query = undefined }
    }
    return { path, query: query && typeof query === 'object' && !Array.isArray(query) ? query : undefined }
  }
}
